export enum EnumTipoBuscaMapa{
    Clientes = 0,
    Revendedores = 1,
}